import * as React from "react";
import { cn } from "@/lib/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  variant?: "default" | "soft";
  textSize?: "sm" | "md";
  invalid?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    { className, variant = "soft", textSize = "md", invalid = false, ...props },
    ref,
  ) => {
    return (
      <textarea
        aria-invalid={invalid || undefined}
        className={cn(
          "flex w-full rounded-md border bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus:outline-none disabled:cursor-not-allowed disabled:opacity-50",
          textSize === "sm" ? "min-h-[64px]" : "min-h-[80px]",
          variant === "soft"
            ? "border-input focus-visible:ring-2 focus:ring-2 focus:ring-primary/30 focus:ring-offset-2 focus:border-primary/40"
            : "border-input focus-visible:ring-2 focus:ring-2 focus:ring-ring focus:ring-offset-2",
          invalid &&
            "border-destructive/50 focus:ring-destructive/30 focus:border-destructive/50",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
